import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import { __ } from "services/Translator";
import api from "services/api";

export default function UpcomingTournaments(props) {
  // popular games settings
  const popularNextLoad = () => {
    popularGameRef.current.slickNext();
  };
  const popularPrevLoad = () => {
    popularGameRef.current.slickPrev();
  };

  const popularGamesSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          className: "center",
          centerMode: true,
        },
      },
    ],
  };

  const popularGameRef = useRef();

  const [highlightedGames, setHighlightedGames] = useState([]);
  const getHighlightedGames = async (ev) => {
    var response = await api.get("/get-highlighted-games");
    if (response.status === 200) {
      setHighlightedGames(response.data.highlightedGames);
    }
  };

  useEffect(() => {
    getHighlightedGames();
  }, []);

  return (
    <section className="game_section">
      <div className="container">
        <div className="section_headline margin_top_15">
          <div className="headline_text">Upcoming Tournaments</div>
        </div>

        <div className="games_lists margin_top_15 margin_bottom_30">
          <Link className="single_tournament" to="#">
            <div className="turnament_img">
              <img
                alt="Game image"
                src="https://chimpbytes.imgix.net/turnaments_1.png?&dpr=2&format=auto&auto=format&q=1&w=264&h=372&max-age=2629056"
              />
            </div>
            <div className="text_area">
              <div className="turnament_name uppercase">Fifa</div>
              <div className="turnament_name">Championship Final</div>
            </div>
          </Link>
          <Link className="single_tournament" to="#">
            <div className="turnament_img">
              <img
                alt="Game image"
                src="https://chimpbytes.imgix.net/turnaments_2.png?&dpr=2&format=auto&auto=format&q=1&w=264&h=372&max-age=2629056"
              />
            </div>
            <div className="text_area">
              <div className="turnament_name uppercase">POKER</div>
              <div className="turnament_name">Championship Final</div>
            </div>
          </Link>
          <Link className="single_tournament" to="#">
            <div className="turnament_img">
              <img
                alt="Game image"
                src="https://chimpbytes.imgix.net/turnaments_1.png?&dpr=2&format=auto&auto=format&q=1&w=264&h=372&max-age=2629056"
              />
            </div>
            <div className="text_area">
              <div className="turnament_name uppercase">CS:GO 2020</div>
              <div className="turnament_name">Championship Final</div>
            </div>
          </Link>
          <Link className="single_tournament" to="#">
            <div className="turnament_img">
              <img
                alt="Game image"
                src="https://chimpbytes.imgix.net/turnaments_2.png?&dpr=2&format=auto&auto=format&q=1&w=264&h=372&max-age=2629056"
              />
            </div>
            <div className="text_area">
              <div className="turnament_name uppercase">POKER</div>
              <div className="turnament_name">Championship Final</div>
            </div>
          </Link>
          <Link className="single_tournament" to="#">
            <div className="turnament_img">
              <img
                alt="Game image"
                src="https://chimpbytes.imgix.net/turnaments_1.png?&dpr=2&format=auto&auto=format&q=1&w=264&h=372&max-age=2629056"
              />
            </div>
            <div className="text_area">
              <div className="turnament_name uppercase">Fifa</div>
              <div className="turnament_name">Championship Final</div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
